import '../css/Content.css';
import React, { useState, useEffect, useRef  } from 'react';
import { Carousel, Modal, Button } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import QuizActivity from './QuizActivity';

export const Lesson = () => {
  const [mostraTexto, setMostraTexto] = useState({});
  const [mostraTexto2, setMostraTexto2] = useState({});
  const [mostraTexto3, setMostraTexto3] = useState({});
  const [mostraTexto4, setMostraTexto4] = useState({});

  const toggleTexto = (id) => {
    setMostraTexto((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleTexto2 = (id) => {
    setMostraTexto2((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleTexto3 = (id) => {
    setMostraTexto3((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const toggleTexto4 = (id) => {
    setMostraTexto4((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [grupoAtivo, setGrupoAtivo] = useState('');

  // Simula o setTimeout da função original
  useEffect(() => {
    const timeout = setTimeout(() => {
      // avancarConteudo(getCookie("avancar"));
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);


  const handleClick = (grupo) => {
    setGrupoAtivo(grupo);
  };


  const containerRef = useRef(null);
  const imageRefs = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom = (event) => {
    const zoomContainer = containerRef.current;
    const rect = zoomContainer.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    Object.values(imageRefs).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom = () => {
    Object.values(imageRefs).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };


  const containerRef2 = useRef(null);
  const imageRefs2 = {
    img1: useRef(null),
    img2: useRef(null),
    img3: useRef(null),
    img4: useRef(null)
  };

  const applyZoom2 = (event) => {
    const zoomContainer2 = containerRef2.current;
    const rect2 = zoomContainer2.getBoundingClientRect();
    const x2 = event.clientX - rect2.left;
    const y2 = event.clientY - rect2.top;

    const xPercent2 = (x2 / rect2.width) * 100;
    const yPercent2 = (y2 / rect2.height) * 100;

    Object.values(imageRefs2).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transformOrigin = `${xPercent2}% ${yPercent2}%`;
        ref.current.style.transform = 'scale(2)';
      }
    });
  };

  const resetZoom2 = () => {
    Object.values(imageRefs2).forEach((ref) => {
      if (ref.current) {
        ref.current.style.transform = 'scale(1)';
        ref.current.style.transformOrigin = 'center center';
      }
    });
  };

  const [openIndex, setOpenIndex] = useState(null);
  const [openIndex2, setOpenIndex2] = useState(null);
  const [openIndex3, setOpenIndex3] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const toggleAccordion2 = (index) => {
    setOpenIndex2(openIndex2 === index ? null : index);
  };
  const toggleAccordion3 = (index) => {
    setOpenIndex3(openIndex3 === index ? null : index);
  };

  // ************ MODAL 1 *********************

    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "", description: "" });
   

    // Função para abrir modal e definir conteúdo
    const openModal = (e) => {
      const target = e.currentTarget;
      console.log(target)
      setModalContent({
        title: target.dataset.title,
        description: target.dataset.description,
        image: target.dataset.image,
      });
      setShowModal(true);

    }
    

    
  // ************ MODAL 2 *********************

    const [showModal2, setShowModal2] = useState(false);
    const [modalContent2, setModalContent2] = useState({ title: "", description: ""});
    

    // Função para abrir modal e definir conteúdo
    const openModal2 = (e) => {
      const target2 = e.currentTarget;
      console.log(target2)
      setModalContent2({
        title: target2.dataset.title,
        description: target2.dataset.description,
        image: target2.dataset.image,
      });
      setShowModal2(true);

    }



  // ************ MODAL 3 *********************

    const [showModal3, setShowModal3] = useState(false);
    const [modalContent3, setModalContent3] = useState({ title: "", description: ""});
    

    // Função para abrir modal e definir conteúdo
    const openModal3 = (e) => {
      const target3 = e.currentTarget;
      console.log(target3)
      setModalContent3({
        title: target3.dataset.title,
        description: target3.dataset.description,
        image: target3.dataset.image,
      });
      setShowModal3(true);

    }


  //   const [showModal, setShowModal] = useState(false);
  // const [activeIndex, setActiveIndex] = useState(0);

  // // Função para abrir o modal e definir o índice do item clicado
  // const openModal = (e) => {
  //   const index = parseInt(e.currentTarget.dataset.index);
  //   setActiveIndex(index);
  //   setShowModal(true);
  // };

   

  return (
    <>      
      <section className="article" id="article_1" style={{background: 'linear-gradient(161deg, #05A3C7 25%, #001755 100%) fixed',
        backgroundAttachment: 'fixed'}}> {/* className: gradient-background */}
       

        {/* TELA 1 */}
        <article id='l1id1'
         style={{
            display: 'flex',
            minHeight: '100vh',
            background: '#131326',
            position: 'relative'
          }}>



          <div className="container">
            <div
              className="row d-flex align-items-center justify-content-center fontS-18"
              style={{ paddinBottom: "80px", marginTop: '40px' }}
            >

              <div className="col-md-6">
                  <h4 style={{marginBottom: '40px', color: '#ffffff'}}>Olá! Bem-vindos ao <span style={{color: '#00A8D0'}}>Módulo I do Curso de Projeto Hidrossanitário – BIM. </span> </h4>

                  <img src="./img/module1/bg_modulo1_pag1.jpg" style={{width: '100%'}} alt="" />
              </div>


              <div className="col-md-6" style={{height: '85vh', display: 'flex', alignItems: 'center'}}>
                <div style={{ width: '90%', marginTop: '30px', padding: '5% 5% 10% 5% ', borderRadius: '12px', color: '#ffffff', background: 'linear-gradient(161deg, #05A3C7 25%, #000000ff 80%)'}}>
                  <p>
                    Aqui você vai aprender os fundamentos da modelagem BIM, conhecer as normas e boas práticas para a elaboração de projetos hidrossanitários, explorar os principais softwares da área e dar os 
                    primeiros passos no ambiente de modelagem. Também veremos como organizar o trabalho com templates, fases de construção e revisões, garantindo clareza e padronização do seu projeto. 
                    Esse módulo será a base para você avançar com segurança nas próximas etapas do curso. <strong>Vamos começar?</strong> 
                  </p>              
                </div>
              </div>
              

            </div>
          </div>

        </article>

                        

        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l1id2'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module1/topico2-m1.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>



        {/* ---------------------------- TELA 2 --------------------------------------- */}

        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#ffffff" 
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  Imagine uma edificação sendo projetada por diferentes profissionais, cada um atuando de forma isolada e sem um sistema para integrar todas as informações do projeto. 
                  Você saberia dizer qual seria o resultado disso? Certamente, haveria erros de compatibilização, retrabalho e custos elevados. 
                  Essa é uma realidade ainda muito comum nos canteiros de obra e que evidencia a importância de métodos que centralizem dados e garantam mais precisão.
                </p>
                <p style={{ color: "#000000" }}>
                  É nesse cenário que surge a Modelagem da Informação da construção, o <strong>BIM (Building Information Modeling).</strong>
                </p>
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <img src="./img/module1/modulo1_pag2.png" style={{width: '80%'}} alt="A imagem mostra uma pessoa no computador e sobreposto alguns ícones e ao centro a palavra BIM." />
            </div>
          </div>
        </article>
        

        {/* ---------------------------- TELA 3 --------------------------------------- */}

        <article
          className="post comecoM2-t"
          style={{ 
            // display: "none", 
            backgroundColor: "#ede6d8" 
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  Quando falamos de projetos hidrossanitários, essa integração é ainda mais estratégica. Redes de água, esgoto, 
                  reservatórios e pontos de consumo precisam estar perfeitamente articulados com a arquitetura e demais instalações, 
                  para que o sistema funcione de forma eficiente, segura e sustentável. O BIM, ao possibilitar a modelagem tridimensional 
                  associada a informações técnicas, permite que o projetista visualize e antecipe conflitos, otimize soluções e aumente a confiabilidade do projeto. 
                </p>               
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <div className='col-md-8'>
                <img src="./img/module1/modulo1_pag3.2.png" style={{width: '100%'}} alt="A imagem mostra engenheiros trabalhando em um projeto hidrossanitário." />
              </div>

            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{ color: "#000000" }}>
                  E você, está preparado para mergulhar nesse universo? A seguir, você vai explorar conceitos essenciais do BIM e entender como ele se aplica à modelagem de projetos hidrossanitários. Vamos lá! 
                </p>               
              </div>
            </div>
            

          </div>
        </article>


        {/* ---------------------------- TELA 4 --------------------------------------- */}
        
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="row">
              <h3 className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                <strong>Modelos: Vínculos, Elementos, Instâncias e Propriedades</strong>
              </h3>
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                O modelo em BIM é um conjunto estruturado de informações que reúne geometria, dados técnicos e relações entre diferentes sistemas da edificação. 
                Ao criar um modelo digital, o projetista não apenas “desenha” a rede hidrossanitária, mas organiza informações que poderão ser analisadas, 
                compatibilizadas e extraídas em forma de documentação. Vamos conhecer alguns conceitos importantes que fazem parte desse processo? 
              </p>
            </div>

            {[1, 2, 3, 4].map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Vínculos</strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Elementos</strong>}
                          {index === 2 && <strong>Instâncias</strong>}
                          {index === 3 && <strong>Propriedades</strong>}
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Os vínculos estão associados a capacidade de referenciar 
                              elementos externos dentro do modelo principal. Quando 
                              tratamos de projetos multidisciplinares, a vinculação 
                              de objetos acaba se tornando extremamente útil para que 
                              cada equipe consiga trabalhar em disciplinas específicas. 
                              Como, por exemplo, um projeto de instalações prediais deve 
                              referenciar o modelo arquitetônico e o modelo estrutural 
                              para garantir a sua integração de forma adequada.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Os elementos são os componentes individuais que constituem o modelo. Esses podem ser 
                              variados, abrangendo desde elementos arquitetônicos e estruturais, até elementos de 
                              instalações mecânicas, elétricas e hidráulicas. Cada elemento é modelado de acordo com
                              suas dimensões e características específicas.
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 2 && (
                        <div className="row" style={{ paddingTop: "5%", paddingBottom: "5%" }}>
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Instância é a cópia individual de um elemento dentro do modelo. 
                              Por exemplo, se houver várias unidades idênticas de um determinado equipamento, 
                              cada uma delas é uma instância desse elemento. As instâncias podem ser repetidas 
                              e posicionadas conforme necessário no projeto. 
                            </p>
                          </div>                        
                        </div>
                      )}

                      {index === 3 && (
                        <div className="row" style={{ paddingTop: "5%", paddingBottom: "5%" }}>
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              São informações adicionais associadas a cada elemento do modelo. Isso inclui detalhes como dimensões, 
                              materiais, informações técnicas, datas importantes e qualquer outro atributo relevante. 
                              As propriedades são cruciais para fornecer informações contextuais e garantir que o modelo contemple informações úteis. 
                            </p>
                          </div>                      
                        </div>
                      )}                      
                    </div>
                  )}
                </div>
              );
            })}

             <div className="row">             
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                Agora que você já compreendeu como esses conceitos trazem uma base sólida dentro de um modelo BIM de projetos hidrossanitários, veja a seguir outros conceitos relevantes nesse processo.
              </p>
            </div>
          </div>
        </article>

        {/* ---------------------------- TELA 5 --------------------------------------- */}
        <article className="post comeco1" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="container">
            <div className="row" style={{ marginBottom: '90px', justifyContent: 'center' }}>
              <div
                className="col-md-12 fontS-18"
                style={{
                  marginBottom: '60px',
                  paddingBottom: '20px',
                  // borderBottom: '1.3px solid #386388',
                }}
              >
                <h3 style={{color: '#ffffff', marginBottom: '40px'}}>
                  <strong>Elementos de Modelo e Elementos de Anotação</strong>
                </h3>
                <p style={{ color: '#ffffff' }}>
                  Ao desenvolver um projeto em BIM, é importante compreender que nem todas as informações inseridas no ambiente digital representam algo físico da edificação. Sendo assim, temos dois tipos de elementos, o de modelo e o de anotações, veja a seguir:  
                </p>
              </div>

              {[1, 2].map((id) => (
                <div className="col-md-4" style={{ marginBottom: '20px', position: 'relative' }} key={id}>
                  <div
                    className="card-container"
                    onClick={() => toggleTexto(`beneficio${id}`)} // Gira o card quando clicado
                  >
                    <div className={`card ${mostraTexto[`beneficio${id}`] ? 'flipped' : ''}`} style={{border: 'none', minHeight: '300px', borderRadius: '15px'}}>
                      {/* Frente do card */}
                      <div className="card-face card-front" style={{ backgroundColor: id === 1 ? '#479FC4' : '#47c47fff' }}>
                        <p className="col-md-12 title-size" style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
                          {id === 1 && (
                            <>
                              <img
                                src="./img/icon/seta_indica.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 80,
                                }}
                              />
                            </>
                          )}
                          {id === 1 ? "Elementos de modelo" : ""}
                          {id === 2 ? "Elementos de anotação" : ""}
                        </p>
                        <img
                          id={`seta1-m${id}`}
                          className="pulse-image"
                          src={id === 1 ? "./img/module1/seta_indica.svg" : ""}
                          alt=""
                          style={{
                            position: 'absolute',
                            height: 'auto',
                            maxWidth: '80px',
                            right: 0,
                          }}
                        />
                      </div>

                      {/* Verso do card */}
                      <div className="card-face card-back">
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                          {id === 1
                            ? "São as representações tridimensionais dos objetos que fazem parte da edificação. No caso dos sistemas hidrossanitários, são as tubulações, conexões, reservatórios, bombas, caixas de inspeção e peças sanitárias. Esses elementos possuem propriedades específicas (como material, diâmetro, vazão) e participam diretamente da análise e compatibilização do projeto."
                            : ""}
                          {id === 2
                            ? "Representam as informações gráficas que auxiliam na leitura, entendimento e documentação do projeto. São exemplos: cotas, textos explicativos, setas de direção de fluxo, símbolos de nível ou inclinação, e demais indicações que enriquecem a comunicação visual."
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row" style={{marginTop: '40px'}}>
              <div className="col-md-12 fontS-18">
                <p style={{ color: '#ffffff' }}>
                  A combinação entre esses dois tipos de elementos é essencial para que o BIM cumpra seu papel de integrar informações e facilitar a comunicação entre projetistas, executores e demais profissionais da construção civil.
                </p>
              </div>
            </div>
          </div>
        </article>



        {/* ---------------------------- TELA 6 --------------------------------------- */}
        <article className="post comeco1" style={{  
          display: 'flex', 
          alignItems: 'center',
          backgroundColor: '#ffffff' 
          // display: grupoAtivo  === 'comeco1' ? 'block' : 'none' 
          }}>
          <div className="container" style={{ paddingBottom: '60px'}}>

            <div className="row" style={{marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">
                <h3 style={{color: '#000000'}}>
                  <strong>Documentação: Anotações, Plantas Bidimensionais, Tabelas, Relatórios e Quantitativo</strong>
                </h3>
                <p style={{color: '#000000'}}>
                  A etapa de documentação é onde o modelo digital se transforma em informações organizadas para consulta, análise e execução da obra. Mais do que representar graficamente, a documentação traduz os dados do modelo em formatos que podem ser interpretados por diferentes profissionais. Fazem parte dessa documentação: 
                </p>
              </div>
            </div>

            <div className="row" style={{ justifyContent: 'center' }}>
              {[1, 2, 3, 4].map((id) => (
                <div className="col-md-5" key={id} style={{ margin: '20px' }}>
                  <div className="card-container" onClick={() => toggleTexto2(`beneficio${id}`)}>
                    <div className={`card ${mostraTexto2[`beneficio${id}`] ? 'flipped' : ''}`} style={{border: 'none', minHeight: '170px', borderRadius: '15px'}}>
                      <div className="card-face card-front" style={{ backgroundColor: id === 1 ? '#479FC4' : id === 2 ? '#47c47f' : id === 3 ? '#4ab58d' : '#47bfc4' }}>
                        <p className='title-size' style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                           {id === 1 && (
                            <>                              
                              <img
                                src="./img/icon/seta_indica.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 40,
                                }}
                              />
                            </>
                          )}
                          {id === 1 && "Anotações"}
                          {id === 2 && "Plantas bidimensionais"}
                          {id === 3 && "Tabelas e relatórios"}
                          {id === 4 && "Quantitativos"}
                        </p>
                      </div>
                      <div className="card-face card-back">
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                          {id === 1 && "contém informações técnicas, como o diâmetro de um tubo, especificação de materiais, notas de projeto, instruções de montagem e outras informações relevantes."}
                          {id === 2 && "fornecem informações sobre como elementos de projeto estão interconectados, nos permitindo obter uma visualização mais abrangente de como estão distribuídas as instalações."}
                          {id === 3 && "incluem listas de componentes, materiais, dimensões e demais propriedades que sejam relevantes."}
                          {id === 4 && "permite que a quantificação dos materiais seja realizada de forma precisa, podendo, inclusive, ser subdividida para etapas de projeto e para determinadas áreas."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{color: '#000000'}}>
                  Cada uma dessas informações contextualizam o projeto, de modo que ele seja compreensível e realizável em suas diferentes etapas. Assim, durante a etapa de execução da obra, esses documentos ajudam os construtores a entenderem as especificações, garantindo que o projeto hidrossanitário seja comunicado de forma clara e padronizada. 
                </p>
              </div>
            </div>
          </div>
        </article>



        {/* ---------------------------- TELA 7 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">
                <h3 style={{color: '#ffffff', marginBottom: '40px'}}>
                  <strong>Interoperabilidade, Comunicação e Colaboração</strong>
                </h3>
                <p style={{color: '#ffffff'}}>
                  A interoperabilidade, comunicação e colaboração são elementos fundamentais ao processo da modelagem da informação da construção, pois sem eles não existiriam a coordenação, troca de informações e cooperação entre equipes. 
                </p>
                <p style={{color: '#ffffff'}}>
                  Assista ao vídeo e confira um pouco mais sobre esse assunto:
                </p>
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Z8jizHUENyc?si=qxovAtQSEeBgfxVd" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Percebeu como esses conceitos formam o tripé que sustenta a metodologia BIM? Juntas, tornam o desenvolvimento de projetos, muito mais preciso, eficiente e colaborativo.
                </p>
              </div>
            </div>
        
          </div>
        </article>
        


        {/* ---------------------------- TELA 8 --------------------------------------- */}

        <article
          className="post comecoM2-t"
          style={{
            // display: "none",
            // backgroundImage: "url(./img/module1/bg_modulo1.png)",
            backgroundColor: '#EDE6D8',
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container" style={{ marginBottom: "60px" }}>
            <div className="col-md-12" style={{ marginBottom: "30px" }}>
              <h3 className="fontS-18" style={{ color: '#000000', marginBottom: '40px' }}>
                <strong>Métodos e Técnicas de Modelagem BIM</strong>
              </h3>
              <p className="fontS-18" style={{ color: '#000000' }}>
                A modelagem BIM necessita de métodos e técnicas para a criação de representações digitais precisas e colaborativas. Nos projetos de instalações hidrossanitárias os métodos orientam como os elementos deverão ser modelados, conectados e organizados, já as técnicas incluem abordagens específicas para tratar de desafios das mais diversas complexidades. Dentre as principais práticas podemos citar:
              </p>
            </div>

            <div
              id="carouselM2Pag7"
              className="carousel slide"              
              data-ride="false"
              data-interval="false">         



              <Carousel indicators={true} controls={true} interval={null} >
                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "0px",
                      // marginLeft: "0px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Elementos Paramétricos </h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                      São criados com parâmetros que podem ser ajustados de forma dinâmica.
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Modelagem por Componentes</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                     Envolve a criação de elementos individuais que representam componentes específicos das instalações hidrossanitárias.
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Modelagem por Superfícies e Sólidos</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                      Modelagem por Superfícies e Sólidos
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Modelagem Generativa</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                      Envolve o uso de algoritmos e lógica computacional para criar automaticamente formas e elementos com base em critérios de projeto
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Modelagem Colaborativa</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                      Envolve equipes multidisciplinares, trabalhando simultaneamente em um único modelo, integrando as diferentes disciplinas envolvidas no projeto de instalações hidrossanitárias.
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Simulação e Análise</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                      Usada para simular o desempenho dos sistemas sob diferentes condições, como fluxo de água, pressão e carga hidráulica.
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "16px",
                      // marginLeft: "20px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                       margin: "0 auto", // 🔹 Centraliza o slide
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Detecção de Conflitos</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                     Usada para identificar colisões entre os elementos dos diferentes projetos.
                    </p>
                  </div>
                </Carousel.Item>

                <Carousel.Item>
                  <div
                    style={{
                      width: '60%',
                      marginLeft: '20%',
                      backgroundColor: "#ffffff",
                      borderRadius: '12px',
                      height: "350px",
                      // marginTop: "33px",
                      // marginLeft: "40px",
                      padding: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <h3 style={{ marginBottom: "20px", color: '#00A8D0', fontSize: '40px' }}>Gestão de Versões e Revisões</h3>
                    <p className="fontS-18" style={{ textAlign: "justify" }}>
                     Usada para acompanhar versões, identificar alterações e gerenciar revisões é essencial para manter o modelo atualizado e garantir a precisão
                    </p>
                  </div>
                </Carousel.Item>
              </Carousel>

            </div>

            <div className="col-md-12" style={{ marginBottom: "30px", marginTop: "80px" }}>
              <p className="fontS-18" style={{ color: '#000000' }}>
                A combinação dessas abordagens torna-se uma boa prática na elaboração de um projeto, visto que sua aplicação trará maior fluidez e eficiência no processo de implantação da modelagem BIM das instalações hidrossanitárias. Além de definir os métodos e técnicas que serão usados para a modelagem, é preciso também ter atenção quanto ao uso de normas. 
              </p>
            </div>
          </div>
        </article>

        {/* ---------------------------- TELA 9 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          // display: 'none', 
          backgroundColor: '#131326' 
          }}>
          <div className="container" style={{ marginBottom: 60 }}>
            <div className="row" style={{ marginBottom: 30 }}>
              <h3 className='title-size' style={{ fontSize: 36, color: '#00A8D0', fontWeight: 500, marginBottom: '40px' }}>
                <strong>Normas para Elaboração de Modelos Digitais</strong> 
              </h3>
              <p style={{ fontSize: 36, fontWeight: 500, color: '#ffffff' }}>
                A criação de modelos digitais em BIM não depende apenas do domínio do software, mas também do atendimento a normas e diretrizes técnicas que asseguram padronização, clareza e qualidade da informação. No Brasil, essas diretrizes são estabelecidas principalmente pela Associação Brasileira de Normas Técnicas (ABNT). 
              </p>
              <p style={{ fontSize: 36, fontWeight: 500, color: '#ffffff' }}>
                Atualmente existem duas normas brasileiras em vigor sobre a modelagem da informação da construção, são elas:
              </p>
            </div>

                      <div className="row fontS-18" style={{ marginTop: '40px', marginBottom: '30px' }}>
            <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  background: 'linear-gradient(to bottom, #e6e6e600 55%, #006191 0%)',
                  width: '100%',
                  height: '220px',
                  paddingTop: '2%',
                  borderRadius: '12px',
                  border: '2px solid #1c7fa0 '
                }}
              >
                <p className='width95'
                  style={{
                    backgroundColor: '#629fb9',
                    color: '#ffffff',
                    fontWeight: 400,
                    padding: '5%',
                    width: '95%',
                    height: '87%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: '12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <ul>
                    <li style={{marginBottom: '20px'}}><strong>ABNT NBR ISO 19650-1:</strong> Organização da informação acerca de trabalhos da construção - Gestão da informação usando a modelagem da informação da construção - Parte 1: Conceitos e princípios;</li>
                    <li><strong>ABNT NBR ISO 19650-2:</strong> Organização da informação acerca de trabalhos da construção - Gestão da informação usando a modelagem da informação da construção - Parte 2: Fase de entrega de ativos.</li>
                  </ul>
                </p>
              </div>
            </div>
          </div> 


            <div className="row" style={{ marginBottom: 30, marginTop: 30 }}>
              <p style={{ fontSize: 36, color: '#ffffff', fontWeight: 500 }}>
                Essas normas proporcionam diretrizes claras para a utilização eficaz de modelos digitais ao longo do ciclo de vida de um projeto, além de garantir a qualidade e a colaboração na indústria da construção. Além das normas para modelos digitais, existem normas especificas que são usadas para a elaboração de projetos hidrossanitários, veja a seguir.
              </p>
            </div>
          </div>
        </article>
        


        {/* ---------------------------- TELA 10 --------------------------------------- */}

        <article className="post comeco1" style={{  
          display: 'flex', 
          alignItems: 'center',
          backgroundColor: '#EDE6D8' 
          // display: grupoAtivo  === 'comeco1' ? 'block' : 'none' 
          }}>
          <div className="container" style={{ paddingBottom: '60px'}}>

            <div className="row" style={{marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">
                <h3 className='title-size' style={{color: '#000000'}}>
                  <strong>Normas para Elaboração de Projetos Hidrossanitários</strong>
                </h3>
                <p style={{color: '#000000'}}>
                  A elaboração de projetos hidrossanitários exige o cumprimento rigoroso de normas técnicas que garantem a segurança, funcionalidade, higiene e eficiência dos sistemas prediais de água fria, água quente, esgoto sanitário e águas pluviais. Entre as principais normas utilizadas estão: 
                </p>
              </div>
            </div>

            <div className="row" style={{ justifyContent: 'center' }}>
              {[1, 2, 3, 4].map((id) => (
                <div className="col-md-5" key={id} style={{ margin: '20px' }}>
                  <div className="card-container" onClick={() => toggleTexto3(`beneficio${id}`)}>
                    <div className={`card ${mostraTexto3[`beneficio${id}`] ? 'flipped' : ''}`} style={{border: 'none', minHeight: '140px', borderRadius: '15px'}}>
                      <div className="card-face card-front" style={{ backgroundColor: id === 1 ? '#479FC4' : id === 2 ? '#47c47f' : id === 3 ? '#4ab58d' : '#47bfc4' }}>
                        <p className='title-size' style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                           {id === 1 && (
                            <>                              
                              <img
                                src="./img/icon/seta_indica.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 40,
                                }}
                              />
                            </>
                          )}
                          {id === 1 && "NBR 5626"}
                          {id === 2 && "NBR 8160"}
                          {id === 3 && "NBR 10844"}
                          {id === 4 && "NBR 15527"}
                        </p>
                      </div>
                      <div className="card-face card-back">
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                          {id === 1 && "Sistemas prediais de água fria e água quente - Projeto, execução, operação e manutenção;"}
                          {id === 2 && "Sistemas prediais de esgoto sanitário - Projeto e execução;"}
                          {id === 3 && "Instalações prediais de águas pluviais;"}
                          {id === 4 && "Aproveitamento de água de chuva de coberturas para fins não potáveis - Requisitos."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{color: '#000000'}}>
                  Dominar essas normas torna-se indispensável na elaboração de projetos hidrossanitários seguros, eficientes e em conformidade com os requisitos legais. A aplicação correta dessas diretrizes garante não apenas a funcionalidade dos sistemas de água e esgoto, mas também a proteção da saúde pública, a preservação ambiental e a viabilidade da aprovação junto aos órgãos competentes. 
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* ---------------------------- TELA 11 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#ffffff'       
        }}>


          <div className="container" style={{paddingBottom: '80px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#000000' }}>
                <h3 className='title-size'>
                  <strong>Softwares BIM para Projetos Hidrossanitários</strong> 
                </h3>  
                <p>
                  Não existiria a modelagem BIM se não fossem os softwares de criação e gerenciamento de modelos. Essas ferramentas são fundamentais para que profissionais das mais diversas disciplinas possam trabalhar e colaborar em um ambiente virtual tridimensional, com eficiência e precisão. 
                </p>  
                <p>
                  Entre os softwares mais populares para o desenvolvimento de projetos hidrossanitários, temos:  
                </p>    
                    
              </div>
            </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "60px",
                  marginBottom: "40px",
                }}
              >
              <div className="col-md-4">
                <img src="./img/module1/modulo1_pag11.1.png" style={{width: '80%'}} alt="" />
              </div>  
              <div className="col-md-4">
                <img src="./img/module1/modulo1_pag11.2.png" style={{width: '80%'}} alt="" />
              </div>  
              <div className="col-md-4">
                <img src="./img/module1/modulo1_pag11.3.png" style={{width: '80%'}} alt="" />
              </div>  
              
            </div>

            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 60, borderRadius: 12 }}>            
              <div className="col-md-12 fontS-18" style={{ marginTop: '40px'}}>
                <p>
                  Cada um deles possuem uma variedade de recursos e funções, contudo, é necessário seguir algumas referências, como as usadas no Sistema Internacional de Unidades (SI), para que esses softwares modelem apresentando dados e informações consistentes.    
                </p>               
              </div>
            </div>
          </div>
        </article>


        {/* ---------------------------- TELA 12 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                
                <p style={{color: '#ffffff'}}>
                  Assista ao vídeo a seguir e verifique as principais referências utilizadas em softwares BIM.
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDn1W_ErU1k?si=VKOMunbm0Z4Wyfu-" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>             
              
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Agora que você já sabe quais as referências usadas para a modelagem de projetos hidrossanitários, conheça mais detalhadamente a interface do software Autodesk Revit, pois essa será a nossa ferramenta base para criar modelos digitais.
                </p>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 13 --------------------------------------- */}
        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#EDE6D8'       
        }}>


          <div className="container" style={{paddingBottom: '80px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#000000' }}>
                <h3 className='title-size'>
                  <strong>Interface Gráfica do Software</strong> 
                </h3>  
                <p>
                  Assim como outros softwares BIM, o Revit organiza sua interface em áreas específicas. Para o desenvolvimento de sistemas hidrossanitários, destacamos a guia “Sistemas”, localizada na parte superior da tela. É nesta aba que se concentram os principais comandos para criar e editar tubos, conexões, acessórios, equipamentos hidráulicos e conexão de hidráulica. Elementos presentes nas redes de água fria, quente, esgoto sanitário e águas pluviais.
                </p> 
                <p>
                  Observe a seguir, como aparece essas ferramentas dentro do Revit.
                </p>                 
              </div>
            </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                  marginBottom: "40px",
                }}
              >
              <img src="./img/module1/modulo1_pag13.gif" style={{width: '80%'}} alt="" />
            </div>          
          </div>
        </article>

        {/* ---------------------------- TELA 14 --------------------------------------- */}
        <article
          className="post comecoM2-p3-1t"
          style={{ 
            // display: "none", 
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#ffffff' }}>              
                <p>
                  Além das ferramentas de modelagem, o Revit oferece recursos importantes para o controle do projeto. Um deles é a janela <strong>“Propriedades”</strong>, 
                  onde você pode ajustar os parâmetros de cada elemento inserido. Outro é o <strong>“Navegador de Projeto”</strong>, que organiza todas as vistas, plantas, 
                  cortes, tabelas e folhas de forma estruturada, facilitando o gerenciamento das informações técnicas.  
                </p>      
                <p>
                  Clique nos botões a seguir e veja como esses elementos aparecem na interface do Revit.
                </p>              
              </div>
            </div>

            <div
              className={`modal fade ${showModal ? "show d-block" : ""}`}
              tabIndex="-1"
              style={{ background: "rgba(0,0,0,0.5)", width: '100%', height: '100%' }}
            >
              <div className="modal-xl modal-dialog-centered" style={{height: '100%', display: 'flex', background: 'rgba(25, 53, 78, 0.58)', backdropFilter: 'blur(10px)', paddingRight: '15px', alignItems: 'baseline'}}>
                <div className="modal-content" style={{width: '90%', height: '70%', marginLeft: 'auto', marginRight: 'auto', background: 'none'}}>
                  <div className="modal-header" style={{borderBottom: 'none'}}>
                    {/* <h5 className="modal-title title-size" style={{color: '#C6DD4F'}}>{modalContent3.title}</h5> */}
                    {/* <button type="button" className="btn-close" onClick={() => setShowModal(false)} style={{color: '#ffffff', fontSize: '30px', fontWeight: '500', opacity: '1'}}></button> */}
                  </div>
                  <div className="modal-body">
                    <div className="row"  style={{justifyContent: 'center'}}>
                      <div className="col-md-6" style={{display: 'flex', justifyContent: 'center', padding: '0',}}>
                        <div className='row' style={{width: '100%', justifyContent: 'center', borderRadius: '12px 12px 0 0', backgroundColor: '#ffffff'}}>
                          <div className="col-md-2" >
                            <p className='title-modal3' style={{color: 'ffffff', fontWeight: '500', fontSize: '70px', textAlign: 'center'}}>{modalContent.description}</p>
                          </div>
                          <div  className='col-md-8' >
                            {/* <p className='title-size' style={{color: 'ffffff', fontWeight: '500', fontSize: '32px', textAlign: 'center'}}>Rolamento de rolos cilíndricos</p> */}
                          </div>
                          <div  className='col-md-2' style={{textAlign: 'right'}}>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)} style={{color: '#ffffff', fontSize: '30px', fontWeight: '500', opacity: '1'}}></button>
                          </div>
                        </div>
                      </div>
                      </div>
                      <div className="row"  style={{justifyContent: 'center'}}>
                      <div className="col-md-6" style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                        <div ref={containerRef2} > {/* <div ref={containerRef2} onMouseMove={applyZoom2} onMouseLeave={resetZoom2} > */}
                          {modalContent.image && <img src={modalContent.image} ref={imageRefs2.img1} alt="Zoom 1" id="zoom-image1" style={{Width: '100%', height: 'auto', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px', backgroundColor: '#ffffff'}}/>}
                        </div>
                      </div>
                    </div>
                    
                    
                  </div>
                  {/* <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                      Fechar 
                    </button>
                  </div> */}
                </div>
              </div>
            </div>


            <div
              className="row"
              style={{ marginTop: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div className="col-md-4" style={{ marginBottom: "30px", cursor: 'pointer' }} data-title="PROPRIEDADES" data-description={`1`} data-image="./img/module1/modulo1_pag14.1.png" onClick={openModal}>
                <img src="./img/module1/modulo1_pag14.3.png" style={{width: '100%', marginBottom: '-20px'}} alt="" />

                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    backgroundColor: "#00A8D0",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "95px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    position: 'relative',
                    // boxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    // WebkitBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    // MozBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                  }}
                  // data-title="PROPRIEDADES"
                  // data-description={`1`}
                  // data-image="./img/module1/modulo1_pag14.1.png"
                  // onClick={openModal}
                >
                  <div className="col-md-12">
                    <p                      
                      style={{
                        color: "#ffffff",
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: 0,
                        paddingRight: 0,
                        cursor: "pointer",
                        textAlign: 'center'
                      }}
                    >
                      PROPRIEDADES
                    </p>
                  </div>                 
                    <img
                      id="seta1-m2I2"
                      className="pulse-image"
                      src="./img/icon/seta_indica.svg"
                      alt=""
                      style={{ position: "absolute", height: "auto", maxWidth: "65px", bottom: "-8px" }}
                    />
                </div>
              </div>

              <div className="col-md-4" style={{ marginBottom: "30px", cursor: 'pointer' }} data-title="NAVEGADOR DE PROJETOS"  data-description={`2`} data-image="./img/module1/modulo1_pag14.2.png"onClick={openModal}>

                <img src="./img/module1/modulo1_pag14.4.png" style={{width: '100%', marginBottom: '-20px'}} alt="" />

                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    backgroundColor: "#00A8D0",
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "95px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    // boxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    // WebkitBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    // MozBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                  }}
                  // data-title="Rolamento de rolos cilíndricos"
                  // data-description={`2`}
                  // data-image="./img/module1/modulo1_pag14.1.png"
                  // onClick={openModal}
                >
                  <div className="col-md-12">
                    <p
                      style={{
                        color: "#ffffff",
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: 0,
                        paddingRight: 0,
                        cursor: "pointer",
                        textAlign: 'center'
                      }}
                    >
                      NAVEGADOR DE PROJETOS
                    </p>
                  </div>                  
                </div>
              </div>
            </div>

            {/* MODAL */}
            <div
              className="modal fade bd-Mod2Part3-modal-xl"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
              style={{ backgroundColor: "#19354e94", backdropFilter: "blur(10px)" }}
            >
              <div
                className="modal-dialog modal-xl"
                style={{
                  height: "90%",
                  maxWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="modal-content" style={{ width: "95%", background: "none" }}>
                  {/* <span data-dismiss="modal" style="font-size: 50px; top: 20px; right: 305px; position: fixed; color: #ffffff; cursor: pointer;">X</span> */}
                  {/* <img
                    src="./img/module3/modulo2_pag23_fechar.svg"
                    data-dismiss="modal"
                    style={{ width: "2%", top: "20px", right: "305px", position: "fixed", cursor: "pointer" }}
                    alt="Fechar"
                  /> */}

                  <div>

                  </div>
                </div>
              </div>
            </div>

              <div
                  className="row"
                  style={{
                    marginTop: "30px",
                    marginBottom: "40px",                   
                  }}
                >
                  <p
                    className="fontS-18 col-md-12"
                    style={{ color: "#ffffff" }}
                  >
                    Depois de conhecer a interface do Revit e se familiarizar com as ferramentas básicas para projetos hidrossanitários em BIM, é hora de entender como preparar o ambiente de modelagem. Vamos nessa!
                  </p>
                </div>

          </div>
        </article>

                                

        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l1id3'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module1/topico3-m1.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>




        {/* ---------------------------- TELA 15 --------------------------------------- */}
        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#EDE6D8'       
        }}>


          <div className="container" style={{paddingBottom: '80px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#000000' }}>
                {/* <p className='title-size'>
                  <strong>15 - Preparação Do Ambiente De Modelagem: Primeiros Passos No Software</strong> 
                </p>   */}
                <p>
                  Antes de iniciar a modelagem de um projeto hidrossanitário no Revit, é importante realizar as configurações iniciais do arquivo, já que cada projeto possui particularidades. Entre os principais ajustes está a definição das <strong>Unidades de medida no padrão SI</strong>, fundamentais para o dimensionamento de tubulações, reservatórios e sistemas de abastecimento e esgoto.   
                </p>              
              </div>
            </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                  marginBottom: "40px",
                }}
              >
              <img src="./img/module1/modulo1_pag15.svg" style={{width: '70%'}} alt="A imagem mostra as unidades de medidas no padrão SI para projetos hidrossanitários." />
            </div>  


            <div className="row" style={{ marginTop: '60px' }}>
              <div className="col-md-12 fontS-18">
                <p>
                  Esse cuidado ao definir as unidades de medidas de maneira adequada, assegura a padronização e evita problemas de interpretação ou inconsistências nos cálculos de materiais.
                </p>
              </div>
            </div>


          </div>
        </article>


        {/* ---------------------------- TELA 16 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ 
          // display: 'none', 
          backgroundColor: '#ffffff' 
          // backgroundImage: 'url(./img/module1/bg_modulo2_pag10.png)', 
          // backgroundRepeat: 'no-repeat', 
          // backgroundPosition: 'center', 
          // backgroundSize: 'cover', 
          }}>
          <div className="container">         
            <div className="row" style={{ backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px', borderRadius: '12px', padding: '2%' }}>
              <div className="col-md-6" style={{display: 'flex', justifyContent: 'right'}}>
                <img src="./img/module1/modulo1_pag16.png" style={{ width: '60%' }} alt="" />
              </div>
              <div className="col-md-6 fontS-18" style={{ marginTop: '5%' }}>
                <p style={{textAlign: 'justify'}}>
                  Além disso, também é necessário ajustar elementos como <strong>níveis, eixos, disciplinas, templates de visualização e famílias</strong> específicas para instalações. Esses parâmetros organizam a documentação, facilitam a leitura do modelo e permitem compatibilizar o projeto hidrossanitário com arquitetura e demais disciplinas. Preparar o arquivo corretamente no início garante maior precisão e eficiência em todas as etapas seguintes.
                </p>             
              </div>
            </div>
          </div>
        </article>


        {/* ---------------------------- TELA 17 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                
                <h3 style={{color: '#ffffff', marginBottom: '40px'}}>
                  <strong>Configuração dos Arquivos de Projeto</strong>
                </h3>                
                <p style={{color: '#ffffff'}}>
                  A configuração dos arquivos de projeto é uma etapa fundamental para estabelecer as bases do trabalho na modelagem BIM. Nessa fase, são definidos parâmetros que guiarão todo o desenvolvimento do projeto hidrossanitário. 
                </p>                
                <p style={{color: '#ffffff'}}>
                  Acompanhe vídeo a seguir, com o especialista Dimitri Ferraz um exemplo de como realizar essa configuração.
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/j4iFh7Lo57g?si=wJ5GuRpZ4z0_65k3" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  É importante que as configurações realizadas no arquivo não fiquem restritas a um único projeto, mas sim sejam preservadas e reutilizadas em trabalhos futuros. Pois refazer manualmente cada ajuste demanda tempo e aumenta o risco de inconsistências, por isso a prática recomendada é salvar essas definições em forma de template. 
                </p>
              </div>
            </div>
        
          </div>
        </article>


        {/* ---------------------------- TELA 18 --------------------------------------- */}

        <article className="post avanco5-M2-t" style={{ 
          backgroundColor: '#EDE6D8'       
        }}>


          <div className="container" style={{paddingBottom: '80px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18" style={{ color: '#000000' }}>
                <p>
                  No Revit, são usados arquivos com extensões próprias, mas há suporte ao formato .IFC para importar e exportar dados entre diferentes plataformas BIM.
                </p>  
                <p>
                  As extensões de arquivo nativas do Revit incluem:
                </p>              
              </div>
            </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                  marginBottom: "40px",
                }}
              >
               <div className="col-md-6" style={{ display: 'flex', justifyContent: 'right', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      .rvt - arquivo do projeto; 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'left', marginBottom: '20px' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      .rte - arquivo de template de projetos (arquivo modelo); 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'right' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      .rfa - arquivo de familia; 
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6" style={{ display: 'flex', justifyContent: 'left' }}>
                <div style={{ backgroundColor: '#ffffff', width: '75%', maxWidth: '425px', height: '130px', padding: '2%', border: '1px solid #14A5E2', borderRadius: '12px' }}>
                  <div style={{ backgroundColor: '#14A5E2', height: '100%', padding: '5%', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: '#ffffff', textAlign: 'center', fontSize: '18px' }}>
                      .rft - arquivo de template para criação de famílias (arquivo modelo).
                    </p>
                  </div>
                </div>
              </div>
            </div>  


            <div className="row" style={{ marginTop: '60px' }}>
              <div className="col-md-12 fontS-18">
                <p>
                  Nesse processo devemos considerar a falta de retrocompatibilidade no Revit, pois arquivos criados em versões mais recentes não abrem em versões anteriores. Por exemplo, um arquivo salvo na versão 2024 não será aberto na versão 2023 ou anteriores, o que é essencial em projetos colaborativos com vários participantes.
                </p>
                <p>
                  Como você pode perceber, a configuração dos arquivos é uma das etapas iniciais no desenvolvimento de um projeto, e ele deve estar associado a uma localização ou a um sistema de coordenadas.
                </p>
              </div>
            </div>


          </div>
        </article>

        {/* ---------------------------- TELA 19 --------------------------------------- */}

        {/* <article className="post avanco3-M2-t" style={{ 
          backgroundColor: '#ffffff'           
          }}>
          <div className="container">    
            <div className="row">
              <p>
                <strong>Georreferenciamento</strong>
              </p>  
            </div>     
            <div className="row" style={{ backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px', borderRadius: '12px', padding: '2%' }}>
               <div className="col-md-6 fontS-18" style={{ marginTop: '5%' }}>
                <p>
                  O georreferenciamento é uma forma de realizar a associação das coordenadas geográficas do mundo real ao projeto que está sendo modelado. No ambiente do Revit, isso acaba por ser útil em projetos que tem a necessidade de possuir uma precisão geográfica, que proporciona visualizar o edifício em relação ao terreno.
                </p>             
              </div>

              <div className="col-md-6">
                <img src="./img/module1/modulo1_pag19.png" style={{ width: '90%' }} alt="A imagem demonstra coordenadas geográficas de uma região." />
              </div>
             
            </div>
          </div>
        </article> */}


        {/* ---------------------------- TELA 20 --------------------------------------- */}
        <article className="post avanco3-M2-t" style={{ backgroundColor: "#131326", display: 'flex', alignItems: 'center'}}>
          <div className="container" style={{ marginBottom: "60px" }}>

            <div className="row">
              <p style={{color: '#ffffff'}}>
                <strong>Georreferenciamento</strong>
              </p>  
            </div>     
            <div className="row" style={{ backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '40px', borderRadius: '12px', padding: '2%' }}>
               <div className="col-md-6 fontS-18" style={{ marginTop: '5%' }}>
                <p>
                  O georreferenciamento é uma forma de realizar a associação das coordenadas geográficas do mundo real ao projeto que está sendo modelado. No ambiente do Revit, isso acaba por ser útil em projetos que tem a necessidade de possuir uma precisão geográfica, que proporciona visualizar o edifício em relação ao terreno.
                </p>             
              </div>

              <div className="col-md-6">
                <img src="./img/module1/modulo1_pag19.png" style={{ width: '90%' }} alt="A imagem demonstra coordenadas geográficas de uma região." />
              </div>
             
            </div>

            <div className="row">          
              <p className="fontS-18" style={{ color: "#ffffff", marginBottom: '60px' }}>
                O Revit pode empregar as coordenadas de eixo (GIS) de um arquivo .DWG vinculado, que possui a função de manter a consistência entre a geolocalização e os modelos. Isso pode ser realizado das seguintes formas:
              </p>
            </div>

            {[1, 2].map((item, index) => {
              const isOpen = openIndex2 === index;
              return (
                <div
                  key={index}
                  className="card"
                  style={{ marginBottom: 5, cursor: "pointer" }}
                >
                  <div
                    className="card-header"
                    onClick={() => toggleAccordion2(index)}
                    style={{ backgroundColor: "#D2EBF6" }}
                  >
                    <div className="row">
                      <div className="col-md-1 d-flex justify-content-center align-items-center">
                        <span style={{ fontSize: 28, fontWeight: 700 }}>{item}</span>
                      </div>
                      <div className="col-md-10">
                        <p className="btn-pag39 fontS-18">
                          {index === 0 && (
                            <>
                              <strong>Vinculação de um arquivo .DWG e utilização de coordenadas compartilhadas: </strong>
                              <img
                                src="./img/icon/seta_indica_azul.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 0,
                                }}
                              />
                            </>
                          )}
                          {index === 1 && <strong>Vinculação de um arquivo .DWG e obtenção de suas coordenadas:</strong>}                        
                        </p>
                      </div>
                      <div className="col-md-1 d-flex justify-content-end align-items-center">
                        <span style={{ fontSize: 36, fontWeight: 700 }}>
                          {isOpen ? "-" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {isOpen && (
                    <div className="card-body">
                      {index === 0 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Quando o ponto de levantamento topográfico ou o ponto base do projeto já foi estabelecido 
                              com as coordenadas de eixo (GIS), é possível vincular um arquivo .DWG de terreno e empregar 
                              essas coordenadas para definir as coordenadas compartilhadas, assegurando o posicionamento 
                              preciso do modelo no terreno.
                            </p>
                          </div>                          
                        </div>
                      )}

                      {index === 1 && (
                        <div className="row">
                          <div className="col-md-12 d-flex align-items-center">
                            <p className="fontS-18">
                              Nos casos em que o ponto de levantamento topográfico ou o ponto base do projeto ainda não foram 
                              definidos utilizando as coordenadas de eixo, pode-se vincular um arquivo .DWG de terreno e adquirir 
                              as informações de localização geográfica para estabelecer as coordenadas compartilhadas e posicionar 
                              o modelo de forma precisa no terreno.
                            </p>
                          </div>                        
                        </div>
                      )}
                        
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </article>
                


        {/* ---------------------------- TELA 21 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                
                <p style={{color: '#ffffff'}}>
                  Assista ao vídeo e verifique como realizar a obtenção de coordenadas de um arquivo DWG.
                </p>                           
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/dOy7iFRVnss?si=dMTrFbK2ct-JQtWi" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Agora que você já entendeu como é feito a configuração e obtenção de coordenadas, vamos ao processo de criação de níveis no projeto.   
                </p>
              </div>
            </div>
        
          </div>
        </article>


        {/* ---------------------------- TELA 22 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          // backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                
                <p style={{color: '#ffffff'}}>
                  <strong>Criação de Níveis</strong>
                </p>                
                <p style={{color: '#ffffff'}}>
                  Os níveis de projetos BIM são referências horizontais que representam alturas ou pavimentos dentro do modelo, funcionando como linhas de corte que organizam a estrutura do edifício. Eles servem para definir limites verticais de pisos, tetos, coberturas e outras referências construtivas, garantindo que todos os elementos do projeto sejam posicionados de forma precisa e consistente.  
                </p>                
                <p style={{color: '#ffffff'}}>
                  Acompanhe no vídeo a seguir como criar/importar níveis no Revit
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/EysugOzOAdA?si=qWqh84byHDzyTu7a" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff', textAlign: 'justify'}}>
                  A definição de níveis de projeto geralmente está vinculada ao modelo arquitetônico. No entanto, em projetos hidrossanitários, isso não significa que não 
                  possamos criar níveis específicos. Na maioria das situações, são utilizados os níveis do projeto arquitetônico para facilitar o acompanhamento. Isso ocorre p
                  orque, se houver uma mudança na altura de um pavimento no projeto arquitetônico, as informações são automaticamente ajustadas e atualizadas nos níveis 
                  relacionados ao projeto hidrossanitário.
                </p>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 23 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                
                <p style={{color: '#ffffff'}}>
                  <strong>Níveis de Detalhes</strong>
                </p>                
                <p style={{color: '#ffffff', textAlign: 'justify'}}>
                  A forma de representação do projeto no Revit, pode ser ajustada de acordo com o nível de detalhamento, 
                  um recurso simples de configurar e muito útil no desenvolvimento de modelos. Com essa funcionalidade, 
                  é possível controlar a forma como os elementos aparecem nas vistas, permitindo que uma mesma modelagem 
                  seja representada de maneira mais esquemática, para estudos iniciais, ou de forma mais realista, 
                  para etapas avançadas de apresentação e documentação. Essa flexibilidade garante praticidade e agilidade no processo, 
                  já que a transição entre diferentes tipos de representação pode ser feita em poucos cliques.  
                </p>                
                <p style={{color: '#ffffff'}}>
                  Acompanhe o especialista Dimitri Ferraz e compreenda um pouco mais sobre esse assunto. 
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/lncn1p6rnjs?si=ynXBNyWaNZlFDSwZ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Os níveis de detalhe no Revit tornam a modelagem mais versátil, permitindo usar o mesmo projeto em etapas conceituais ou realistas sem retrabalho, otimizando tempo e garantindo clareza na comunicação visual. 
                </p>
              </div>
            </div>
        
          </div>
        </article>

                                        

        {/* ---------------------------- TELA TÓPICO --------------------------------------- */}

        <article id='l1id4'
            className="post comecoM2-t"
            style={{
              // backgroundImage: "url(./img/module1/topico3-m1.svg)",
              // backgroundRepeat: "no-repeat",
              // backgroundSize: "cover",
              // backgroundPosition: "center",
            }}
          >
          <img
              src="./img/module1/topico4-m1.svg"
              alt="background"
              className="absolute inset-0 w-full h-full object-cover md:object-contain"
              style={{width: '100%'}}
          />

        </article>




        {/* ---------------------------- TELA 24 --------------------------------------- */}
        <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#ffffff',
          }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  No desenvolvimento de modelos BIM, a organização e o controle de documentos são fundamentais para garantir 
                  qualidade e coerência ao longo de todas as etapas de projeto. Sendo assim, os templates assumem um papel 
                  estratégico nesse processo, pois permitem controlar variações e revisões dos desenhos, mantendo um histórico 
                  claro de alterações realizadas, além de possibilitar a configuração das fases do projeto, representando adequadamente cada etapa construtiva com sua documentação associada.   
                </p>                       
              </div>
            </div>

            <div className="row" style={{ backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 40, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-12" style={{display: 'flex', justifyContent: 'center'}}>
                <img src="./img/module1/modulo1_pag24.jpg" style={{ width: '70%' }} alt="" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                 Essa padronização além de agilizar o trabalho, assegura a integridade das informações e a confiabilidade dos modelos produzidos.    
                </p>                       
              </div>
            </div>

          </div>
        </article>

        {/* ---------------------------- TELA 25 --------------------------------------- */}
        <article className="post comeco1" style={{  
          display: 'flex', 
          alignItems: 'center',
          // backgroundColor: '#ffffff' 
          // display: grupoAtivo  === 'comeco1' ? 'block' : 'none' 
          }}>
          <div className="container" style={{ paddingBottom: '60px'}}>

            <div className="row" style={{marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">
                <h3 className='title-size' style={{color: '#ffffff'}}>
                  <strong>Criação de Templates para Projetos Hidrossanitários</strong>
                </h3>
                <p style={{color: '#ffffff'}}>
                  A criação de templates para projetos hidrossanitários organiza previamente o ambiente de modelagem. Dessa maneira, o profissional já inicia o trabalho em um espaço configurado, evitando retrabalhos, acelerando a modelagem e mantendo o alinhamento entre todos os envolvidos no projeto. 
                </p>
                <p style={{color: '#ffffff'}}>
                  O template para projetos hidrossanitários no Revit geralmente é composto por:
                </p>
              </div>
            </div>

            <div className="row" style={{ justifyContent: 'center' }}>
              {[1, 2, 3, 4, 5].map((id) => (
                <div className="col-md-5" key={id} style={{ margin: '20px' }}>
                  <div className="card-container" onClick={() => toggleTexto4(`beneficio${id}`)} style={{marginBottom: '0px', width: '85%'}}>
                    <div className={`card ${mostraTexto4[`beneficio${id}`] ? 'flipped' : ''}`} style={{border: 'none', minHeight: '140px', borderRadius: '15px'}}>
                      <div className="card-face card-front" style={{ backgroundColor: id === 1 ? '#479FC4' : id === 2 ? '#47c47f' : id === 3 ? '#4ab58d' : id === 4 ? '#47bfc4' : '#8fb1c6' }}>
                        <p className='title-size' style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                           {id === 1 && (
                            <>                              
                              <img
                                src="./img/icon/seta_indica.svg"
                                alt=""
                                className="pulse-image"
                                style={{
                                  position: "absolute",
                                  maxWidth: 35,
                                  right: -25,
                                  bottom: 40,
                                }}
                              />
                            </>
                          )}
                          {id === 1 && "NORMAS E PADRÕES GRÁFICOS"}
                          {id === 2 && "FAMÍLIAS BÁSICAS"}
                          {id === 3 && "CONFIGURAÇÕES DE VISTA"}
                          {id === 4 && "UNIDADES E ESCALAS"}
                          {id === 5 && "CONFIGURAÇÕES DE PRANCHAS"}
                        </p>
                      </div>
                      <div className="card-face card-back">
                        <p style={{ fontSize: '16px', textAlign: 'center' }}>
                          {id === 1 && "Estilos de linha, cotas e textos padronizados."}
                          {id === 2 && "Tubulações, conexões, aparelhos sanitários, dispositivos hidráulicos e reservatórios."}
                          {id === 3 && "Cortes, elevações e perspectivas já configuradas ajustadas ao tipo de projeto."}
                          {id === 4 && "Medidas ajustadas ao tipo de projeto."}
                          {id === 5 && "Layouts prontos para documentação."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>            
          </div>
        </article>
                


        {/* ---------------------------- TELA 26 --------------------------------------- */}

          <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#EDE6D8',
          }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Os templates não só definem os padrões de representação gráfica, como também estabelecem os parâmetros, 
                  as famílias de objetos e as configurações essenciais. Isso garante que todos os elementos, desde conexões 
                  a caixas de passagem, estejam consistentes em termos de dimensões, estilos e propriedades.    
                </p>                       
              </div>
            </div>

            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 40, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-12" style={{display: 'flex', justifyContent: 'center'}}>
                <img src="./img/module1/modulo1_pag26.png" style={{ width: '50%', minWidth: '540px' }} alt="" />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Uma das principais vantagens de usar templates no Revit é evitar a repetição de configurações a cada novo projeto. Ao personalizar um arquivo de projeto e salvá-lo como template, criamos um modelo reutilizável que mantém todas as diretrizes definidas. Isso agiliza o início de novos projetos e garante consistência entre eles.     
                </p>                       
              </div>
            </div>

            <div className="row" style={{paddingBottom: '60px'}}>
              <div className="col-md-12 fontS-18">
                <p>
                 Agora que você já sabe a importância da criação de templates para os projetos hidrossanitários, acompanhe a seguir como realizar a criação e configuração de modelos de vistas, as Views templates.   
                </p>                       
              </div>
            </div>

            {/* <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                 Além disso, os templates promovem a conformidade com as normas e regulamentos específicos da indústria, garantindo a qualidade e a precisão do projeto.  No geral, são a base para os projetos hidrossanitários.    
                </p>                       
              </div>
            </div> */}

          </div>
        </article>


        {/* ---------------------------- TELA 27 --------------------------------------- */}
        {/* <article className="post avanco4-M2-t" style={{ 
          display: 'flex',
          alignItems: 'center', 
          backgroundColor: '#EDE6D8',
          minHeight: '300px',
          paddingTop: '0px',
          }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  Uma das principais vantagens de usar templates no Revit é evitar a repetição de configurações a cada novo projeto. Ao personalizar um arquivo de projeto e salvá-lo como template, criamos um modelo reutilizável que mantém todas as diretrizes definidas. Isso agiliza o início de novos projetos e garante consistência entre eles.     
                </p>                       
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                 Agora que você já sabe a importância da criação de templates para os projetos hidrossanitários, acompanhe a seguir como realizar a criação e configuração de modelos de vistas, as Views templates.   
                </p>                       
              </div>
            </div>

          </div>
        </article> */}

        {/* ---------------------------- TELA 28 --------------------------------------- */}
        
        <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#ffffff',
          }}>
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12 fontS-18">
                    <p>
                      <strong>Criação e configuração de modelos de vista (view templates)</strong>
                    </p>
                    <p>
                    Os Modelos de Vista (View Templates) garantem clareza e padronização gráfica ao controlar escala, 
                    aplicar filtros e usar sobreposições. Esses recursos são essenciais para diferenciar sistemas, 
                    destacar elementos ocultos em paredes, pisos ou lajes, além de atribuir cores e padrões que identificam 
                    a função de cada componente hidrossanitário, como tubulações de água fria, quente, esgoto ou ventilação.   
                    </p>                       
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 fontS-18">
                    <p>
                    Esse processo de diferenciação visual vai além da estética, ela é fundamental para a comunicação técnica precisa entre projetistas, equipes de obra e demais disciplinas envolvidas. Ao padronizar as vistas com base em modelos bem configurados, garante-se não apenas eficiência na elaboração das pranchas, mas também maior confiabilidade na leitura e interpretação do projeto hidrossanitário como um todo.    
                    </p>                       
                  </div>
                </div>

              </div>

              <div className="col-md-6">
                
                <div className="row" style={{ backgroundColor: '#ffffff', display: 'flex', justifyContent: 'center', marginBottom: 40, borderRadius: 12, padding: '2%' }}>
                  <div className="col-md-12" style={{display: 'flex', justifyContent: 'center'}}>
                    <img src="./img/module1/modulo1_pag28.png" style={{ width: '40%', minWidth: '470px' }} alt="Imagem mostra vista com sobreposições gráficas de projeto hidrossanitário." />
                  </div>
                </div>

              </div>
      
            </div>

            

          </div>
        </article>

        {/* ---------------------------- TELA 29 --------------------------------------- */}
        <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#131326',
          }}>
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">            
                <p style={{color: '#ffffff'}}>
                 A seguir acompanhe com o nosso especialista como realizar essa configuração na prática: 
                </p>                       
              </div>
            </div>

               <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
                  <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                    <iframe width="100%" height="auto" src="https://www.youtube.com/embed/H9MDSO3LZG4?si=8dr040cZ_ggA03aS" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                  </div>
              </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p style={{color: '#ffffff'}}>
                 Essas configurações permitem que as vistas sejam adaptadas às necessidades específicas do projeto, garantindo que as informações sejam apresentadas de maneira clara e precisa.    
                </p>                       
              </div>
            </div>

          </div>
        </article>

        {/* ---------------------------- TELA 30 --------------------------------------- */}
         <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#EDE6D8',
          }}>
          <div className="container" style={{paddingBottom: '60px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">   
                <p>
                  <strong>Criação e configuração de tabelas</strong>
                </p>         
                <p>
                  As tabelas no BIM são capazes de extrair automaticamente dados dos componentes e famílias do modelo. No entanto, para que isso ocorra, é necessário configurá-las adequadamente, especificando ao software quais informações devem ser coletadas e organizadas.  
                </p>                       
              </div>
            </div>

            <div className="row" style={{ display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 40, borderRadius: 12, padding: '2%' }}>
              <div className="col-md-12">
                <img src="./img/module1/modulo1_pag30.png" style={{ width: '90%' }} alt="A imagem ilustra informações mostrando o caminho para inserir tabelas." />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                 Para obter os dados desejados, como quantidades de materiais ou áreas, é essencial definir previamente o que deseja que seja exibido, e em seguida, formatar as tabelas de acordo com suas necessidades específicas. Esta abordagem não só agiliza a obtenção de informações, mas também resulta em uma documentação precisa do projeto. É como instruir o software para que organize os dados de acordo com as necessidades exatas do momento, poupando tempo e assegurando a precisão dos registros.     
                </p>                       
              </div>
            </div>

          </div>
        </article>


        {/* ---------------------------- TELA 31 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                            
                <p style={{color: '#ffffff'}}>
                  A seguir, veja na prática, um exemplo de como configurar tabelas dento do REVIT. 
                </p>                
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/S37X7Un1qaA?si=Twz0-EthlkohMwhR" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Viu como é simples e prático a criação de tabelas utilizando a metodologia BIM? A seguir veja como configurar as folhas do projeto. 
                </p>
              </div>
            </div>
        
          </div>
        </article>

        {/* ---------------------------- TELA 32 --------------------------------------- */}
        <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#EDE6D8',
          }}>
          <div className="container" style={{paddingBottom: '40px'}}>
            <div className="row">
              <div className="col-md-12 fontS-18">   
                <p>
                  <strong>Criação e configuração de folhas</strong>
                </p>         
                <p>
                  Nas folhas representamos as plantas, cortes, elevações e outras informações. Você deve configurar as folhas de forma a transmitir as informações do projeto de maneira clara e ordenada, isso envolve definir tamanhos, estabelecer escalas apropriadas e dispor as vistas de forma lógica e compreensível.
                  <br/>
                  <br/>
                  Clique nos passos a seguir e verifique como criar folhas utilizando o Revit.

                </p>                       
              </div>
            </div>


            <div
              className={`modal fade ${showModal2 ? "show d-block" : ""}`}
              tabIndex="-1"
              style={{ background: "rgba(0,0,0,0.5)", width: '100%', height: '100%' }}
            >
              <div className="modal-xl modal-dialog-centered" style={{ display: 'flex', background: 'rgba(25, 53, 78, 0.58)', backdropFilter: 'blur(10px)', paddingRight: '15px', alignItems: 'baseline'}}>
                <div className="modal-content" style={{width: '90%', height: '70%', marginLeft: 'auto', marginRight: 'auto', background: 'none', border: 'none'}}>
                  <div className="modal-header" style={{borderBottom: 'none'}}>
                    {/* <h5 className="modal-title title-size" style={{color: '#C6DD4F'}}>{modalContent3.title}</h5> */}
                    {/* <button type="button" className="btn-close" onClick={() => setShowModal(false)} style={{color: '#ffffff', fontSize: '30px', fontWeight: '500', opacity: '1'}}></button> */}
                  </div>
                  <div className="modal-body">
                    <div className="row" style={{display: 'flex', justifyContent: 'center'}}>
                      <div className="col-md-8" style={{display: 'flex', justifyContent: 'center', padding: '0',}}>
                        <div className='row' style={{width: '100%', justifyContent: 'center', borderRadius: '12px 12px 0 0', backgroundColor: '#ffffff'}}>
                          <div className="col-md-2" >
                            <p className='title-modal3' style={{color: 'ffffff', fontWeight: '500', fontSize: '70px', textAlign: 'center'}}>{modalContent2.description}</p>
                          </div>
                          <div  className='col-md-8' >
                            <p className='title-size' style={{color: 'ffffff', fontWeight: '500', fontSize: '32px', textAlign: 'center'}}>{modalContent2.title}</p>
                          </div>
                          <div  className='col-md-2' style={{textAlign: 'right'}}>
                            <button type="button" className="btn-close" onClick={() => setShowModal2(false)} style={{color: '#ffffff', fontSize: '30px', fontWeight: '500', opacity: '1'}}></button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8" style={{textAlign: 'center', padding: '0', overflow: 'hidden', position: 'relative', height: '100%', borderRadius: '0 0 12px 12px'}}>
                        {/* <div ref={containerRef} onMouseMove={applyZoom} onMouseLeave={resetZoom} > */}
                        <div ref={containerRef}>
                          {modalContent2.image && <img src={modalContent2.image} ref={imageRefs.img1} alt="Zoom 1" id="zoom-image2" style={{width: '100%', height: '100%', cursor: 'zoom-in', objectFit: 'contain', display: 'block', borderRadius: '0 0 12px 12px', backgroundColor: '#ffffff'}}/>}
                        </div>
                      </div>
                    </div>
                    
                    
                  </div>
                  
                </div>
              </div>
            </div>
            

            <div
              className="row"
              style={{ marginTop: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div className="col-md-4" style={{ marginBottom: "30px" }}>
                <h3 style={{textAlign: 'center'}}>Passo 1</h3>
                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    // backgroundColor: "#ffffff",
                    backgroundImage: 'url(./img/module1/modulo1_pag32.1.png)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "180px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    boxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    WebkitBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    MozBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                  }}
                  data-title="PASSO 1"
                  data-description={`1`}
                  data-image="./img/module1/modulo1_pag32.1.png"
                  onClick={openModal2}
                >
                  <div className="col-md-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src="./img/module1/modulo1_pag32_zoom.png" style={{width: '30%', minWidth: '100px', minHeight: '100px'}} alt="" />
                  </div>                
                </div>
              </div>

              <div className="col-md-4" style={{ marginBottom: "30px" }}>
                <h3 style={{textAlign: 'center'}}>Passo 2</h3>
                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    // backgroundColor: "#ffffff",
                    backgroundImage: 'url(./img/module1/modulo1_pag32.2.png)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "180px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    boxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    WebkitBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    MozBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                  }}
                     data-title="PASSO 2"
                  data-description={`2`}
                  data-image="./img/module1/modulo1_pag32.2.png"
                  onClick={openModal2}
                >
                  <div className="col-md-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src="./img/module1/modulo1_pag32_zoom.png" style={{width: '30%', minWidth: '100px', minHeight: '100px'}} alt="" />
                  </div>                 
                </div>
              </div>


              <div className="col-md-4" style={{ marginBottom: "30px" }}>
                <h3 style={{textAlign: 'center'}}>Passo 3</h3>
                <div
                  className="row"
                  data-toggle="modal"
                  data-target=".bd-Mod2Part3-modal-xl"
                  style={{
                    width: "100%",
                    marginLeft: 0,
                    // backgroundColor: "#ffffff",
                    backgroundImage: 'url(./img/module1/modulo1_pag32.3.png)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    display: "flex",
                    justifyContent: "right",
                    alignItems: "center",
                    fontWeight: 500,
                    minHeight: "180px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    borderRadius: "5px",
                    boxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    WebkitBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                    MozBoxShadow: "0px 11px 0px 0px rgba(71,159,196,1)",
                  }}
                  data-title="PASSO 3"
                  data-description={`3`}
                  data-image="./img/module1/modulo1_pag32.3.png"
                  onClick={openModal2}
                >
                  <div className="col-md-12" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <img src="./img/module1/modulo1_pag32_zoom.png" style={{width: '30%', minWidth: '100px', minHeight: '100px'}} alt="" />
                  </div>                
                </div>
              </div>

            </div>

            {/* MODAL */}
            <div
              className="modal fade bd-Mod2Part3-modal-xl"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
              style={{ backgroundColor: "#19354e94", backdropFilter: "blur(10px)" }}
            >
              <div
                className="modal-dialog modal-xl"
                style={{
                  height: "90%",
                  maxWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="modal-content" style={{ width: "95%", background: "none" }}>
                  {/* <span data-dismiss="modal" style="font-size: 50px; top: 20px; right: 305px; position: fixed; color: #ffffff; cursor: pointer;">X</span> */}
                  {/* <img
                    src="./img/module3/modulo2_pag23_fechar.svg"
                    data-dismiss="modal"
                    style={{ width: "2%", top: "20px", right: "305px", position: "fixed", cursor: "pointer" }}
                    alt="Fechar"
                  /> */}

                  <div>

                  </div>
                </div>
              </div>
            </div>
            
            

            <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                 Originalmente o Revit tem uma folha padrão, porém é possível carregar diferentes famílias de folhas.      
                </p>                       
              </div>
            </div>

          </div>
        </article>



        {/* ---------------------------- TELA 33 --------------------------------------- */}
        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                            
                <p style={{color: '#ffffff'}}>
                  Após criar e configurar os modelos de vista, tabelas e folhas, chega o momento de reunir tudo em um único arquivo, o template.  
                </p>  
                  
                <p style={{color: '#ffffff'}}>
                  Acompanhe a seguir, com o especialista Valter Junior como criar e configurar um template no Revit.
                </p>           
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/U9ZzHxjxXgI?si=R9qiYgIzeC2R4MCA" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#ffffff'}}>
                  Agora que você já compreendeu como realizar as configurações de templates, veja como organizar a documentação técnica através das configurações de fases da construção do modelo e do controle de revisões do modelo.  
                </p>
              </div>
            </div>
        
          </div>
        </article>
                


        {/* ---------------------------- TELA 34 --------------------------------------- */}
        <article className="post avanco4-M2-t" style={{ 
          // display: 'none' 
          backgroundColor: '#EDE6D8',
          }}>
          <div className="container" style={{paddingBottom: '40px'}}>
            <div className="row">

              <div className="col-md-6">

                <div className="col-md-12 fontS-18">   
                  <p>
                    <strong>Configuração de Fases de Construção para a Modelagem</strong>
                  </p>         
                  <p>
                    As configurações de fases da modelagem permitem controlar o ciclo de vida dos elementos, indicando o que já existe, será mantido, construído ou demolido. Esse recurso é especialmente útil em reformas e retrofits, trazendo clareza na identificação de tubulações, conexões e equipamentos hidrossanitários. Com isso, o projeto ganha organização, confiabilidade e melhor suporte à compatibilização entre disciplinas e à tomada de decisões durante a obra.  
                  </p>                       
                </div>

                <div className="col-md-12 fontS-18">
                  <p>
                    A representação gráfica desse controle é feita por meio de cores, padrões de linhas e legendas específicas, que diferenciam visualmente cada situação (existente, novo, demolido ou temporário). Assim, o modelo se transforma em uma ferramenta dinâmica de comunicação, facilitando a compreensão do projeto por toda a equipe envolvida, desde engenheiros e arquitetos até gestores de obra.      
                  </p>                       
                </div>

              </div>

              <div className="col-md-6">
                
                <div className="row" style={{ display: 'flex', justifyContent: 'center', marginBottom: 40, borderRadius: 12, padding: '2%' }}>
                  <div className="col-md-12">
                    <img src="./img/module1/modulo1_pag34.PNG" style={{ width: '85%' }} alt="Imagem mostra controle de sobreposição gráfica do REVIT em tubulações." />
                  </div>
                </div>
              </div>

            </div>


            {/* <div className="row">
              <div className="col-md-12 fontS-18">
                <p>
                  A representação gráfica desse controle é feita por meio de cores, padrões de linhas e legendas específicas, que diferenciam visualmente cada situação (existente, novo, demolido ou temporário). Assim, o modelo se transforma em uma ferramenta dinâmica de comunicação, facilitando a compreensão do projeto por toda a equipe envolvida, desde engenheiros e arquitetos até gestores de obra.      
                </p>                       
              </div>
            </div> */}

          </div>
        </article>



        {/* ---------------------------- TELA 35 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#131326'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">                            
                <p style={{color: '#ffffff'}}>
                  No vídeo a seguir, você poderá ver, de forma prática, como a ferramenta de controle de fases é aplicada.  
                </p>                     
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/brNGfXdjvVM?si=2fZ_lfQprn91gwUx" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>       
          </div>
        </article>



        {/* ---------------------------- TELA 36 --------------------------------------- */}

        <article className="post comecoM2-t" style={{
          backgroundColor: '#ffffff'
        }}>
          <div className="container" style={{ paddingBottom: '40px' }}>

            <div className="row" style={{ marginBottom: '40px'}}>
              <div className="col-md-12 fontS-18">  
                <p style={{color: '#000000'}}>
                  <strong>Organização e Controle de Revisões do Modelo</strong>
                </p>                          
                <p style={{color: '#000000'}}>
                  O controle de revisões no Revit é uma ferramenta que auxilia no registro e na comunicação de alterações realizadas ao longo do desenvolvimento do projeto. A cada modificação, é possível criar uma nova revisão, vinculando-a às pranchas e desenhos correspondentes. Isso permite acompanhar de forma transparente o que foi modificado, quando e por qual motivo, garantindo a rastreabilidade, clareza na comunicação entre a equipe, além de trazer mais segurança no trabalho colaborativo.
                </p>  
                  
                <p style={{color: '#000000'}}>
                  Acompanhe no vídeo a seguir com o especialista Valter Junior um exemplo de como realizar revisões no Revit.
                </p>           
              </div>
            </div>

            <div className="row d-flex align-items-center justify-content-center fontS-18" style={{ paddingBottom: '60px' }}>        
              <div style={{ width: '80%', minHeight: '500px', display: 'flex', justifyContent: 'center' }}>
                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Ep3MyEjjWP8?si=upKXTw02UJJKmzd0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 fontS-18">              
                <p style={{color: '#000000'}}>
                  Observou como o uso do recurso de revisões no Revit organiza a documentação técnica? Esse recurso garante a eficiência do projeto e assegura que todos os profissionais trabalhem com a versão mais atualizada do modelo, fortalecendo a integração da equipe.  
                </p>
              </div>
            </div>
        
          </div>
        </article>
                




        {/*---------------------------- TELA QUESTÔES ---------------------------------- --> */}
        
        <article
          className="post avanco7-M2-t"
          style={
            {
              // display: "none",
              // backgroundColor: "#304F64"
            }
          }
        >
          <div className="container">
            {/* ENCERRAMENTO DO MÓDULO */}
            <div
              style={{
                backgroundColor: "#EDE6D8",
                padding: "60px 20px",
                borderRadius: "12px",
                textAlign: "center",
                marginTop: "60px",
                marginBottom: "60px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <h2
                style={{
                  color: "#131326",
                  fontSize: "32px",
                  fontWeight: "700",
                  marginBottom: "25px",
                }}
              >
                🛠️ Vamos exercitar?
              </h2>

              <p
                style={{
                  color: "#131326",
                  fontSize: "18px",
                  lineHeight: "1.6",
                  maxWidth: "800px",
                  margin: "0 auto 30px auto",
                  textAlign: "justify",
                }}
              >
                Quer praticar um pouco do que vimos até agora? 
                Preparamos um roteiro com orientações simples para te ajudar a começar. 
                A proposta aqui será criar um template básico de projeto para dar os primeiros passos na modelagem. 
                Para isso, baixe os arquivos a seguir e siga o passo a passo do roteiro. 
              </p>

              <div style={{ marginTop: "30px" }}>
                <p
                  style={{
                    color: "#131326",
                    fontSize: "20px",
                    fontWeight: "600",
                    marginBottom: "15px",
                  }}
                >
                  📥 Baixe aqui os arquivos do Exercitando.
                </p>

                <div className="row">
                  
                </div>

                <a
                  onClick={() => {
                  const link = document.createElement('a');
                  link.href = './downloads/exercitando.docx';
                  link.download = 'Exercitando1.docx';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#131326",
                    color: "#EDE6D8",
                    padding: "12px 30px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    marginRight: '15px'
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0c59a1ff", e.currentTarget.style.cursor = 'pointer')
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#131326")
                  }
                >
                  ⬇️ Download do Roteiro Exercitando 1
                </a>


                <a
                  onClick={() => {
                  const link = document.createElement('a');
                  link.href = './downloads/FamiliasHidrossanitario_Exercitando01.rar';
                  link.download = 'FamiliasHidrossanitario.rar';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                  style={{
                    display: "inline-block",
                    backgroundColor: "#131326",
                    color: "#EDE6D8",
                    padding: "12px 30px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontSize: "18px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0c59a1ff", e.currentTarget.style.cursor = 'pointer')
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#131326")
                  }
                >
                  ⬇️ Download do Famílias Hidrossanitário Exercitando
                </a>
              </div>
            </div>
          </div>
        </article>

       
        {/* ---------------------------- TELA 37 --------------------------------------- */}

        <article
          className="avanco8-M2-t"
          style={{
            // display: "none",
            display: 'flex',
            minHeight: "100vh",
            backgroundColor: '#EDE6D8'
            // backgroundImage: "url(./img/module1/bg_modulo2_pag49.png)",
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover",
          }}
        >
          <div className="container" style={{ marginTop: "50px", display: "flex" }}>
            <div className="row" style={{ justifyContent: "center", alignItems: "center" }}>
              <div
                className="col-md-8"
                style={{
                  padding: 0,
                  minHeight: "400px",
                  background: "linear-gradient(133deg, rgba(255, 255, 255, 0.94) 15%, rgba(253, 255, 246, 0.94) 75%)",
                  borderRadius: "12px",
                   display: 'flex',
                  alignItems: 'center'
                }}
              >
                <p style={{ padding: "5% 7%" }}>
                  <strong>Parabéns!</strong> Você chegou ao final da primeira etapa da nossa trilha de conhecimento. Até aqui, você explorou os fundamentos da <strong>Modelagem da Informação da Construção aplicados a Projetos Hidrossanitários</strong>, desde os conceitos do BIM até a preparação do ambiente e a configuração dos arquivos para criar um fluxo eficiente e organizado. 
                  Lembre-se o aprendizado é contínuo e sua dedicação irá contribuir para seu sucesso profissional.
                  <strong>Boa sorte!</strong>                 
                </p>
              </div>
            </div>
          </div>
        </article>








      </section>
    </>
  );
};

export default Lesson;